import AreaHub from 'components/area-hub/area-hub';
import Area from 'components/area-hub/area';
import Case from 'components/area-hub/case';

const gamePagesData = {
	areaHub: {
		component: AreaHub,
		background: 'office',
		infoTitle: '!VIGTIG BESKED!',
		infoText: `Velkommen til <b>HHX</b> og jeres studiejob hos <b>Future Business A/S</b>.
			<br /><br />Nu skal I udforske, hvordan <b>HHX</b> hænger sammen med de opgaver, man kan arbejde med bagefter.
			<br /><br /><b>Future Business A/S</b> udvikler og driver forretningskoncepter inden for økonomi, strategi og vækst i Danmark og internationalt.
			<br /><br />Jeres opgave er at tage <b>de bedste beslutninger for virksomheden</b> - og for jeres hold. I konkurrerer mod de andre hold og vinder ved at <b>svare rigtigt og undgå fejl</b>.
			<br /><br />I skal besøge HHX-uddannelsen og virksomhedens forskellige områder og afdelinger, hvor I løser udfordringer og træffer beslutninger. 
			<br />Nogle opgaver kræver viden - <b>andre kræver, at I tænker jer frem.</b>
			<br /><br />I kan starte, <b>hvor I vil</b>. Hvert område indeholder udfordringer, som giver point, når I løser dem.
			<br /><br />Hvis I vil vinde, handler det ikke om at svare hurtigt - men om at svare rigtigt.
			<br />Der er et <b>begrænset antal udfordringer</b>, så tænk jer om: <b>Jo færre fejl, I laver, jo flere point får I.</b>
			<br /><br />Klik rundt, løs opgaverne, indtil tiden løber ud - og se, om I kan slå de andre hold.
			<br /><br /><b>Held og lykke - og husk, at I kan følge stillingen på pointtavlen!</b>`,
		routes: [
			{
				id: 'sales',
				name: 'Salg & Marketing',
				pageId: 'areaSales'
			},
			{
				id: 'it',
				name: 'IT-sikkerhed & Ledelse',
				pageId: 'areaIt'
			},
			{
				id: 'economy',
				name: 'Økonomi & International Handel',
				pageId: 'areaEconomy'
			},
			{
				id: 'investment',
				name: 'Investering & Finansiering',
				pageId: 'areaInvestment'
			},
			{
				id: 'education',
				name: 'Uddannelsen & Fremtiden',
				pageId: 'areaEducation'
			},

		]
	},
	areaSales: {
		component: Area,
		caseComponent: Case,
		id: 'sales',
		name: 'Salg & Marketing',
		background: 'sales',
		infoTitle: 'Salg & Marketing',
		infoText: `Dette er virksomhedens salgs- og marketingafdeling. Afdelingen arbejder med salg, reklame og analyse af markedet for at sikre virksomhedens vækst.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: `Priser`,
				pageId: null,
				text: `Hvad Future Business A/S produkter skal koste og hvorfor er et af de helt centrale spørgsmål for virksomheden.`
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: `Kundeservice`,
				pageId: null,
				text: `<b>Kundeservice er afgørende for Future Business A/S.</b> 
					<br /><br />Besøg afdelingen og se, om I kan hjælpe med at finde de bedste løsninger for kunderne.`
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: `Online salg`,
				pageId: null,				
				text: `<b>Future Business A/S vil lancere en webshop.</b> 
					<br /><br />Hvad er vigtigt at overveje.`
			},
			{
				id: 4,
				title: 'Udfordring 4',
				subtitle: 'Distributionskæden',
				pageId: null,
				text: `<b>Vejen fra idé til kunde kaldes distributionskæden.</b>
					<br /><br />Alle trin i distributionskæden spiller en vigtig rolle for Future Business A/S.`,
			},
			{
				id: 5,
				title: 'Udfordring 5',
				subtitle: 'Kommunikation',
				pageId: null,
				text: `<b>I skal tage stilling til, hvordan Future Business A/S fremstår udadtil.</b>
					<br /><br />Det handler både om indretning, design og om at ramme den rigtige målgruppe.`,
			},
			{
				id: 6,
				title: 'Udfordring 6',
				subtitle: 'Sociale medier',
				pageId: null,
				text: `Der er stort fokus på sociale medier.
					<br /><br /><b>Hvordan vil I markedsføre jer her?</b>`,
			}
		]
	},
	areaEconomy: {
		component: Area,
		caseComponent: Case,
		id: 'economy',
		name: 'Økonomi & International Handel',
		background: 'economy',
		infoTitle: 'Økonomi & International Handel',
		infoText: `Dette er virksomhedens afdeling for økonomi og international handel. Afdelingen arbejder med budgetter, regnskab og handel på tværs af landegrænser.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'SKAT',
				pageId: null,
				text: `<b>Virksomheder skal oplyse bestemte ting til SKAT.</b>
					<br /><br />Det handler om de oplysninger, myndighederne skal bruge.`
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Vigtige tal',
				pageId: null,
				text: `I en økonomiafdeling arbejder man med mange vigtige tal.
					<br /><br />Hjælp økonomiafdelingen i <b>Future Business A/S</b>.`
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Indkøb',
				pageId: null,
				text: `<b>Indkøb er en central del af Future Business A/S</b>.
					<br /><br />Det handler om at finde de rigtige løsninger til den rigtige pris.`
			},
			{
				id: 4,
				title: 'Udfordring 4',
				subtitle: 'International økonomi',
				pageId: null,
				text: `<b>Future Business arbejder i en verden, hvor økonomien går op og ned - både i Danmark og i andre lande.</b> 
					<br /><br />Her skal I hjælpe virksomheden med at forstå, hvordan samfundets økonomi kan påvirke kunder, priser og beslutninger.`
			}
		]
	},
	areaIt: {
		component: Area,
		caseComponent: Case,
		id: 'it',
		name: 'IT-sikkerhed & Ledelse',
		background: 'it',
		infoTitle: 'IT-sikkerhed & Ledelse',
		infoText: `Dette er virksomhedens afdeling for IT-sikkerhed og ledelse. Afdelingen arbejder med beskyttelse af data og systemer samt med ledelse og beslutninger i virksomheden.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'IT & Datasikkerhed',
				pageId: null,
				text: `Et ryddeligt IT-område gør arbejdet nemmere og mere sikkert.
					<br /><br /><b>Hjælp Future Business A/S med at skabe overblik i IT-afdelingen</b>.`,
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Website',
				pageId: null,
				text: `<b>Ledelsen skal vælge et nyt website-design</b>.
					<br /><br />Det skal vise, at virksomheden er sikker, professionel og til at stole på.`
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Ledelsens mål for virksomheden',
				pageId: null,
				text: `<b>Future Business A/S er i udvikling</b>.
					<br /><br />For at virksomheden kan vokse, kræver det klare og realistiske mål.`,
			},
			{
				id: 4,
				title: 'Udfordring 4',
				subtitle: 'Rettigheder',
				pageId: null,
				text: `<b>Virksomheder lader sig ofte inspirere af hinanden for at følge trends</b>.
					<br /><br />Men hvis inspirationen bliver for tæt, kan man risikere at krænke andres rettigheder.
					<br /><br /><b>Et af jeres nye koncepter minder meget om en kendt konkurrent</b>.
					<br />Er det inspiration - eller er det gået for langt?`
			},
			{
				id: 5,
				title: 'Udfordring 5',
				subtitle: 'Uforudsete hændelser',
				pageId: null,
				text: `<b>Som en del af jeres studiejob hjælper I ledelsen med at reagere på det, der sker i verden</b>.
					<br /><br />Derfor er det vigtigt at være opdateret på dagens nyheder.`
			},
			{
				id: 6,
				title: 'Udfordring 6',
				subtitle: 'Medarbejdere',
				pageId: null,
				text: `<b>God kommunikation er vigtig i arbejdet med medarbejdere</b>.
					<br /><br />Det handler om, hvordan ledelsen kommunikerer internt i virksomheden`
			},
			{
				id: 7,
				title: 'Udfordring 7',
				subtitle: 'Ledelsesviden',
				pageId: null,
				text: `<b>Ledelsen mangler overblik</b>.
					<br /><br />Hjælp dem med at få styr på informationen om virksomheden.`
			}
		]
	},
	areaInvestment: {
		component: Area,
		caseComponent: Case,
		id: 'investment',
		name: 'Investering & Finansiering',
		background: 'investment',
		infoTitle: 'Investering & Finansiering',
		infoText: `Her arbejder virksomheden med investeringer og finansiering. Afdelingen træffer beslutninger om, hvordan penge investeres, og hvordan virksomhedens aktiviteter finansieres.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Investering',
				pageId: null,
				text: `<b>For at vokse og udvikle sig må Future Business bruge penge i dag for at tjene flere i morgen</b>. 
					<br /><br />Her skal I hjælpe ledelsen med at vurdere muligheder, risiko og vælge de investeringer, der giver mest mening.`,
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Finansiering',
				pageId: null,
				text: `<b>Når Future Business vil investere og vokse, skal pengene komme et sted fra</b>. 
					<br /><br />Her hjælper I ledelsen med at finde ud af, hvordan investeringer kan betales - og hvilke valg der giver mest mening.`,
			}
		]
	},	
	areaEducation: {
		component: Area,
		caseComponent: Case,
		id: 'education',
		name: 'Uddannelsen & Fremtiden',
		background: 'education',
		infoTitle: 'Uddannelsen & Fremtiden',
		infoText: `Her får I indblik i uddannelsens fag, studieretninger og hverdag - samt hvilke muligheder den kan føre til bagefter.`,
		routes: [
			{
				id: 1,
				title: 'Udfordring 1',
				subtitle: 'Om HHX',
				pageId: null,
				text: `<b>Her tager vi de første skridt ind i HHX-verdenen.</b>
					<br /><br />Prøv opgaver, der giver jer et hurtigt og enkelt indblik i, hvad HHX handler om.`,
			},
			{
				id: 2,
				title: 'Udfordring 2',
				subtitle: 'Uddannelsen',
				pageId: null,
				text: `<b>Tid til at dykke ned i, hvordan det er at gå på HHX.</b>
					<br /><br />Her får I et hurtigt indblik i, hvordan uddannelsen er bygget op, og hvad det egentlig vil sige at være en del af den.`,
			},
			{
				id: 3,
				title: 'Udfordring 3',
				subtitle: 'Fremtiden',
				pageId: null,
				text: `<b>Nu ser vi på, hvad der kan ske efter gymnasiet.</b>
					<br /><br />Der er masser af muligheder - og masser af point at hente.`,
			},
			{
				id: 4,
				title: 'Udfordring 4',
				subtitle: 'Studieretninger og fag',
				pageId: null,
				text: `Her skal I tjekke spændende fakta om studieretninger og fag - og få styr på det vigtigste.`
			},
			{
				id: 5,
				title: 'Udfordring 5',
				subtitle: 'Obligatoriske fag',
				pageId: null,
				text: `<b>Velkommen til fagverdenen på %school%!</b>
					<br /><br />Her bliver I udfordret på, hvilke fag der er vigtige, hvordan niveauerne fungerer, og hvilke fag I selv kan vælge.`
			}
		]
	},
	
};

export {
	gamePagesData,
};